"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./StudiosHeader.module.css";

export function StudiosHeader({
  as: _Component = _Builtin.Block,
  studioDisplayName = {},
  roomDisplayName = {},
  studioName = "",
  roomName = "",
}) {
  return (
    <_Component
      className={_utils.cx(_styles, "studios---header-wrapper")}
      tag="div"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "breadcrumb---wrapper")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "breadcrumb", "text-links")}
          tag="div"
        >
          {"Studios"}
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "breadcrumb", "arrows")}
          tag="div"
        >
          {">"}
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "breadcrumb", "text-links")}
          tag="div"
          {...studioDisplayName}
        >
          {studioName}
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "breadcrumb", "arrows")}
          tag="div"
        >
          {">"}
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "breadcrumb", "text-links")}
          tag="div"
          {...roomDisplayName}
        >
          {roomName}
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, "div-block-60")} tag="div">
        <_Builtin.Heading
          className={_utils.cx(_styles, "studios")}
          tag="h2"
          {...roomDisplayName}
        >
          {roomName}
        </_Builtin.Heading>
        <_Builtin.Heading
          className={_utils.cx(_styles, "studios", "studio-name")}
          tag="h2"
          {...studioDisplayName}
        >
          {studioName}
        </_Builtin.Heading>
      </_Builtin.Block>
      <_Builtin.HFlex
        className={_utils.cx(_styles, "sub-heading---details")}
        tag="div"
      >
        <_Builtin.HFlex
          className={_utils.cx(_styles, "reviews---wrapper")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "star-rating---wrapper")}
            tag="div"
          >
            <_Builtin.Image
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/648f9054d19795aaf3900911_Star%201.svg"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "bold-text")}
              tag="div"
            >
              {"5.0"}
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "text-block-24")}
            tag="div"
          >
            {"|"}
          </_Builtin.Block>
          <_Builtin.Link
            className={_utils.cx(_styles, "link-4")}
            button={false}
            block=""
            options={{
              href: "#",
            }}
          >
            {"18 Reviews"}
          </_Builtin.Link>
        </_Builtin.HFlex>
        <_Builtin.Block
          className={_utils.cx(_styles, "studios---location-wrapper")}
          tag="div"
        >
          <_Builtin.Block className={_utils.cx(_styles, "location")} tag="div">
            {"NorthHollywood"}
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, "location")} tag="div">
            {", "}
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, "location")} tag="div">
            {"California"}
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, "location")} tag="div">
            {", "}
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, "location")} tag="div">
            {"USA"}
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.HFlex
          className={_utils.cx(_styles, "labels-w-icon")}
          tag="div"
        >
          <_Builtin.Block className={_utils.cx(_styles, "icons")} tag="div">
            <_Builtin.Image
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/63e15e17e6f81a8baa2a901d_Trophies_Verified.svg"
            />
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "atmos-enabled")}
            tag="div"
          >
            {"Dolby Atmos Enabled"}
          </_Builtin.Block>
        </_Builtin.HFlex>
      </_Builtin.HFlex>
      <_Builtin.Block className={_utils.cx(_styles, "div-block-58")} tag="div">
        <_Builtin.Block
          className={_utils.cx(_styles, "div-block-62")}
          tag="div"
        >
          <_Builtin.HFlex
            className={_utils.cx(_styles, "labels-w-icon")}
            tag="div"
          >
            <_Builtin.Block className={_utils.cx(_styles, "icons")} tag="div">
              <_Builtin.Image
                loading="lazy"
                width="16"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/63e15e17e6f81a8baa2a901d_Trophies_Verified.svg"
              />
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "studios---basic-label")}
              tag="div"
            >
              {"Verified Studio"}
            </_Builtin.Block>
          </_Builtin.HFlex>
          <_Builtin.HFlex
            className={_utils.cx(_styles, "labels-w-icon")}
            tag="div"
          >
            <_Builtin.Block className={_utils.cx(_styles, "icons")} tag="div">
              <_Builtin.Image
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/648ff7ad0b1fe69ddc6da557_Group%204147.svg"
              />
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "studios---basic-label")}
              tag="div"
            >
              {"Top Studio"}
            </_Builtin.Block>
          </_Builtin.HFlex>
          <_Builtin.HFlex
            className={_utils.cx(_styles, "labels-w-icon")}
            tag="div"
          >
            <_Builtin.Block className={_utils.cx(_styles, "icons")} tag="div">
              <_Builtin.Image
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/648ff7a6f75399278bb63c24_Group%204153.svg"
              />
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "studios---basic-label")}
              tag="div"
            >
              {"Booked 256 Times"}
            </_Builtin.Block>
          </_Builtin.HFlex>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "div-block-61")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "labels-w-icon")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "alt-text-labels")}
              tag="div"
            >
              {"SHARE"}
            </_Builtin.Block>
            <_Builtin.Block className={_utils.cx(_styles, "icons")} tag="div">
              <_Builtin.Image
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/648ff926fd1699ec8b2f7dcb_Vector.svg"
              />
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.HFlex
            className={_utils.cx(_styles, "labels-w-icon")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "alt-text-labels")}
              tag="div"
            >
              {"SAVE"}
            </_Builtin.Block>
            <_Builtin.Block className={_utils.cx(_styles, "icons")} tag="div">
              <_Builtin.Image
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/648ff92c9513baa9534eb9d1_Vector-1.svg"
              />
            </_Builtin.Block>
          </_Builtin.HFlex>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
